import React from 'react';

import ClampedParagraph from '@rover/components/src/typography/ClampedParagraph';
import { Flex, Text } from '@rover/kibble/core';
import Avatar from '@rover/kibble/patterns/Avatar';

export type Props = {
  reviewText?: string | null;
  description: string;
  reviewPhotoUrl?: string | null;
  reviewerShortName?: string | null;
};

const LINES = 4;

const StaticFeaturedReview: React.FC<Props> = ({
  reviewText,
  description,
  reviewPhotoUrl,
  reviewerShortName,
}: Props) => {
  const hasReviewText = !!reviewText;
  const hasReviewerName = !!reviewerShortName;

  return (
    <Flex flexDirection="column" gap="1x" flex="1" height="100%">
      {hasReviewText && hasReviewerName ? (
        <>
          <ClampedParagraph lines={LINES}>
            <>&ldquo;{reviewText}&rdquo;</>
          </ClampedParagraph>
          <Flex gap="2x" flexDirection="row" alignItems="center" sx={{ mt: 'auto' }}>
            <Avatar imageUrl={reviewPhotoUrl ?? null} type="dog" size="small" />
            <Text textAlign="center" textColor="secondary" size="100">
              {reviewerShortName}
            </Text>
          </Flex>
        </>
      ) : (
        <ClampedParagraph lines={LINES}>
          {/* DEV-104195: Translate */}
          About: <span itemProp="description">{description}</span>
        </ClampedParagraph>
      )}
    </Flex>
  );
};

export default StaticFeaturedReview;
